export const pricingCategory = (
  type:
    | string
    | Record<string, any> =
  "series"
) => {
  const categories: Record<string, Record<string, string>> = {
    series: {
      "adult": "Adult",
      "single_supplement": "Adult (Single Room)",
      "child_twin": "Child twin",
      "child_with_bed": "Child with Extra bed",
      "child_no_bed": "Child without bed",
      // "infant": "Infant",
      // "dta_adult": "DTA Adult",
      // "dta_child_no_bed": "DTA Child no bed",
      // "dta_child_twin": "DTA Child twin",
      // "dta_child_with_bed": "DTA Child with bed",
      // "dta_infant": "DTA Infant",
      // "dta_single_supplement": "DTA Single Supplement",
    },
    cruise: {
      adult: "Adult",
      single_supplement: "Adult (Single Room)",
      child_with_bed: "Child",
    }
  }

  // If the API returns a hash/object, return it directly.
  // If the object has room_types, use that mapping.
  if (type && typeof type === "object" && !Array.isArray(type)) {
    // Handle nested shapes from API
    if (
      "room_types" in type &&
      typeof type.room_types === "object" &&
      type.room_types !== null &&
      !Array.isArray(type.room_types)
    ) {
      return type.room_types as Record<string, string>;
    }
    if (
      "series" in type &&
      typeof type.series === "object" &&
      type.series !== null &&
      !Array.isArray(type.series)
    ) {
      return type.series as Record<string, string>;
    }
    if (
      "tour.room_types" in type &&
      typeof type["tour.room_types"] === "object" &&
      type["tour.room_types"] !== null &&
      !Array.isArray(type["tour.room_types"])
    ) {
      return type["tour.room_types"] as Record<string, string>;
    }

    // If the object looks like a direct mapping of category->label
    const vals = Object.values(type);
    if (vals.length > 0 && vals.every(v => typeof v === "string")) {
      return type as Record<string, string>;
    }

    // As a last resort, only accept a single nested object when the input has exactly one key.
    const keys = Object.keys(type);
    if (keys.length === 1) {
      const value = type[keys[0]];
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        return value as Record<string, string>;
      }
    }
  }

  const key = typeof type === "string" ? type : "series";
  return categories[key] || categories.series;
};

const PRICE_TYPE_NORMAL = "normal";
const PRICE_TYPE_PROMO = "promo";


export const priceTypes = {
  "normal": PRICE_TYPE_NORMAL,
  "normal1": PRICE_TYPE_NORMAL,
  "normal2": PRICE_TYPE_NORMAL,
  "normal3": PRICE_TYPE_NORMAL,
  "normal4": PRICE_TYPE_NORMAL,
  "normal5": PRICE_TYPE_NORMAL,
  "normal6": PRICE_TYPE_NORMAL,
  "normal7": PRICE_TYPE_NORMAL,
  "normal8": PRICE_TYPE_NORMAL,
  "normal9": PRICE_TYPE_NORMAL,
  "early_bird": "early bird",
  "specialoffer": "special offer",
  "specialdeal": "special deal",
  "superpromo": "super promo",
  "promo": PRICE_TYPE_PROMO,
  "promo1": PRICE_TYPE_PROMO,
  "promo2": PRICE_TYPE_PROMO,
  "promo3": PRICE_TYPE_PROMO,
}

export enum PAYMENT_TERMS {
  FULL_PAYMENT = "customer_full_fare",
  DEPOSIT = "customer_deposit"
}